(function() {
    'use strict';

    angular
        .module('atheer.conversation')
        .factory('ConversationMemberUtil', ConversationMemberUtil);

    function ConversationMemberUtil() {
        return {
            getDisplayName: getDisplayName
        };

        function getDisplayName(member) {
            if (!member) {
                return '';
            }

            var fullName = [member.first_name, member.last_name].filter(Boolean).join(' ');
            return fullName || member.email || member.login || member.username || '';
        }
    }
})();
